const normalizeMaxLength = maxLength => value => {
    if (!value) {
        return value;
    }

    if (value.length <= maxLength) {
        return value;
    }

    return undefined;
};

export default normalizeMaxLength;


// WEBPACK FOOTER //
// ./src/helpers/NormalizeMaxLength.js